<template>
  <ul :class="['flex flex-row gap-5 items-center', listClass]">
    <li v-for="link in links" :key="link.id">
      <a
        :href="link.url"
        :aria-label="link.ariaLabel"
        target="_blank"
        rel="noopener"
        :class="[
          'group inline-flex items-center p-[3px] transition-opacity hover:opacity-80 focus-visible:[box-shadow:0_0_0_3px_white]',
          linkClass,
        ]"
      >
        <MBZIcon
          :name="(link.icon as IconName)"
          :class="[
            iconSizeClass,
            'text-mbzuai-sand-500 group-focus-visible:text-mbzuai-dark-navy-500',
          ]"
        />
      </a>
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { IconName } from '~/components/global/MBZ/Icon.vue';
import type { SocialLink } from '~/types';

withDefaults(
  defineProps<{
    links: SocialLink[];
    /** Extra classes for the outer `<ul>` (e.g. alignment, spacing). */
    listClass?: string;
    /** Extra classes for each `<a>` — wrapper colour/spacing hook. */
    linkClass?: string;
    /** Tailwind classes controlling rendered icon height (width auto-derives from each SVG's intrinsic aspect ratio). Default is responsive: smaller on mobile, larger on desktop per Figma. */
    iconSizeClass?: string;
  }>(),
  {
    listClass: '',
    linkClass: '',
    iconSizeClass: 'h-[18px] w-auto',
  },
);
</script>
